import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "../hooks/useLocalizedPath";

export const AppFooter = () => {
  const { t } = useTranslation();
  const lp = useLocalizedPath();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          {/*<a href="mailto:info@predsense.ai" className="footer-email">*/}
          {/*  info@predsense.ai*/}
          {/*</a>*/}
          &copy; 2026 Predsense
        </div>
        <div className="footer-right">
          <Link to={lp("/llm-info")} className="footer-link">
            {t("LlmInfoLink")}
          </Link>
          <Link to={lp("/impressum")} className="footer-link">
            {t("Impressum")}
          </Link>
          <Link to={lp("/blog")} className="footer-link">
            {t("Blog")}
          </Link>
          <Link to={lp("/privacy-policy")} className="footer-link">
            {t("Datenschutz")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
